import type { EffectiveTradeStatus } from './trades.types';

// ── Status Colors ──
//
// The only surviving export from the former trade-detail mock-type module
// (HON-04 sweep, Phase 14). Every fabricated mock-only shape — TradeTransaction
// / TransactionLeg / TransactionEntry / TransactionType / TransactionEventType /
// TRANSACTION_TYPE_COLORS / BackendTransaction / DailyEarning / TradeEarnings /
// TradeDetailData / AuditEvent / RateHistoryEntry / AUDIT_EVENT_COLORS / LegType
// / AccountType / Direction — was deleted alongside trade-detail-mock.ts,
// TransactionCard.tsx and TransactionFlowDiagram.tsx (all zero importers after
// Phases 8–13). The remaining consumer is the shared `StatusPill` primitive
// (LR-208 r5 L1 dropped `TradeDetailHeader.tsx` — superseded by `TradeHeader`).

// LR-497: keyed by EffectiveTradeStatus so the two derived buckets get their own
// pill colour. partially_settled = amber (matches the former ½-glyph accent);
// pending_partial_settlement = purple (distinct from the cyan/teal pending pair).
export const TRADE_STATUS_COLORS: Record<EffectiveTradeStatus, { bg: string; text: string }> = {
  pending: { bg: 'bg-yellow-100', text: 'text-yellow-800' },
  pending_open_settlement: { bg: 'bg-cyan-100', text: 'text-cyan-800' },
  partially_settled: { bg: 'bg-amber-100', text: 'text-amber-800' },
  active: { bg: 'bg-green-100', text: 'text-green-800' },
  pending_partial_settlement: { bg: 'bg-purple-100', text: 'text-purple-800' },
  matured: { bg: 'bg-orange-100', text: 'text-orange-800' },
  closed: { bg: 'bg-blue-100', text: 'text-blue-800' },
  cancelled: { bg: 'bg-red-100', text: 'text-red-800' },
  rejected: { bg: 'bg-red-200', text: 'text-red-900' },  // LR-408
};
